import { useEffect, useState } from "react";

const InactivitySnackbar = () => {
  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    const motivo = sessionStorage.getItem("motivoLogout");
  
    if (motivo === "inactividad") {
      setMostrar(true);
      sessionStorage.removeItem("motivoLogout");
    }
  }, []);

  if (!mostrar) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "60px",
        right: "20px",
        backgroundColor: "rgb(1 100 193)",
        color: "#fff",
        padding: "12px 20px",
        borderRadius: "6px",
        boxShadow: "0 0 12px rgba(0,0,0,0.2)",
        zIndex: 9999,
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        maxWidth: "400px"
      }}
    >
      <span style={{ flex: 1 }}>
        🔒 Por seguridad, su sesión ha sido cerrada automáticamente tras un periodo de inactividad. Por favor, vuelva a iniciar sesión.
      </span>
      <button
        onClick={() => setMostrar(false)}
        title="Cerrar"
        style={{
          background: "transparent",
          border: "none",
          color: "#fff",
          fontSize: "16px",
          cursor: "pointer",
          padding: 0,
          margin: 0,
          lineHeight: 1
        }}
      >
        ✖
      </button>
    </div>
  );
};

export default InactivitySnackbar;
